import $ from 'jquery';
import howtoConfig from '~config/howto.json';
import { colSizes } from '~loader/loader-utils';
import { videoModalId } from '~src/help';

export const templateAddHelp = () => {
  let itemHtml = '';

  for (const category of howtoConfig) {
    if (category.categoryCode === 'PRIMI_PASSI') {
      for (const item of category.items) {
        itemHtml += `
              <div class="${colSizes['regular']} mt-2">
                <div class="howto-item">
                  <div class="howto-item-img-container">`;
        if (item.externalDoc) {
          itemHtml += `
          <a href="${item.externalDoc}" target="_blank"><img class="howto-item-img lazy" src="${item.thumbnail}" /></a>`;
        }
        itemHtml += `</div>
                  <div class="howto-item-button-container">`;
        if (item.externalDoc) {
          itemHtml += `
                    <button class="howto-item-button-bottom" id="editor-sidebar-flip-h">
                      <a href="${item.externalDoc}" title="Guida di approfondimento" target="_blank">Guida</a>
                    </button>`;
        }
        if (item.youtubeVideo) {
          itemHtml += `<button class="howto-item-button-bottom help-video" data-toggle="modal" data-target="${videoModalId}" data-youtube-url="${item.youtubeVideo}">
                        Video
                       </button>`;
        }
        itemHtml += `</div>
                </div>
            </div>`;
      }
    }
  }

  $('#editor-help').html(itemHtml);
};
